import $ from 'jquery'
import ImagerieCliches from '@/components/imagerie-cliches/index.vue'
import ImagerieRapport from '@/components/imagerie-rapport/index.vue'
export default {
    name: 'manage-resultat-examen',
    components: { ImagerieCliches, ImagerieRapport },
    props: { type_examen_id: Number, result_to_fill: { type: Object, default: () => ({}) }, active_role: Object, user_info: Object, rst_toggler: Number },
    data() { return { clichesVisible: false, galleryRevision: 0 } },
    computed: { reportContext() { return { ...this.result_to_fill, ville: this.ville, nom_clinique: this.nom_clinique } } },
    watch: { rst_toggler() { this.clichesVisible = true } },
    mounted() {
        $(this.$refs.rslt_exam).on('hide.bs.modal.imgReport', event => { if (this.$refs.report && !this.$refs.report.canLeave()) event.preventDefault() })
        $(this.$refs.rslt_exam).on('hidden.bs.modal.imgReport', () => { this.clichesVisible = false })
    },
    beforeDestroy() { $(this.$refs.rslt_exam).off('.imgReport') },
    methods: { changed() { this.galleryRevision++; this.$emit('emitRefreshList') } }
}
